// hooks/useReportTokenRefresh.js
import {useEffect} from 'react';

import {shouldUpdateToken} from '../../../utils';

export default function useReportTokenRefresh({report, selectedReport, tokenExpiration, loadReports, setTokenExpiration}) {
  useEffect(() => {
    if (!report) return;

    const INTERVAL_TIME = 10000;
    const interval = setInterval(async () => {
      console.warn('Checking token validity, called every 10 seconds');
      const shouldUpdate = await shouldUpdateToken(tokenExpiration);
      if (shouldUpdate) {
        console.warn('Updating report access token');
        const result = await loadReports();
        if (result.success) {
          const {tokenData} = result;
          setTokenExpiration(tokenData.expiration);
          selectedReport?.setAccessToken(tokenData.token);
        }
      }
    }, INTERVAL_TIME);

    return () => clearInterval(interval);
  }, [report, selectedReport, tokenExpiration, loadReports, setTokenExpiration]);
}
